/* unplugin-vue-components disabled */import script from "./NavAppDownloadEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./NavAppDownloadEntry.vue?vue&type=script&setup=true&lang=js"

import "./NavAppDownloadEntry.vue?vue&type=style&index=0&id=08fa547f&scoped=true&lang=scss"

import exportComponent from "../../../../../../Users/mac/myproject/deepsage/deepsage_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08fa547f"]])

export default __exports__